import {useMutation} from '@apollo/client'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {useEffect} from 'react'
import {toast} from 'react-toastify'
import {Spinner} from '../Spinner'
import {ANULAR_DISPATCH} from '../../graphql/mutations/dispatchMutations'
import {IDataResAnularDispatch} from '../../graphql/types/despachoTypes'
import Lottie from 'lottie-react'
import warningLottie from '../../assets/lotties/warning.json'

interface IModalCancelDispatchProps {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  idDispatch: string
}

export const ModalCancelDispatch: React.FC<IModalCancelDispatchProps> = ({
  isOpen,
  onClose,
  idDispatch,
  refetch,
}) => {
  const [gqlAnularDispatch, {data, loading, error}] =
    useMutation<IDataResAnularDispatch>(ANULAR_DISPATCH)

  useEffect(() => {
    if (error) toast.error('Error: ' + error.message)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.cancelDispacth.success) {
      toast.success('Despacho anulado correctamente')
      onClose()
      refetch()
    } else if (data.cancelDispacth.errors) {
      toast.error('Error: ' + data.cancelDispacth.errors.message)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const hanldeCancel = () => {
    gqlAnularDispatch({
      variables: {
        input: {
          dispatchId: idDispatch,
        },
      },
    })
  }
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className='d-flex align-items-center gap-2 text-danger'>¡CUIDADO!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex align-items-center justify-content-center' style={{height: '45vh'}}>
          <div className='d-flex flex-column gap-4 align-items-center'>
            <div style={{maxWidth: '120px'}}>
              <Lottie animationData={warningLottie} />
            </div>
            <h4 className='text-center fs-1'>Esta acción anulará el despacho</h4>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' type='button' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          className='d-flex align-items-center gap-2'
          variant='danger'
          disabled={loading}
          onClick={hanldeCancel}
        >
          {loading && <Spinner size='16px' color='light' />}
          Anular
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
